import React from "react";
import PropTypes from "prop-types";
import { TableCell, Typography } from "@mui/material";

export default function CustomizedTableBodyCell({
  style,
  backgroundColor,
  cell,
  isScrolling,
  onClick,
}) {
  return (
    <TableCell
      component="div"
      {...cell.getCellProps({ style })}
      onClick={onClick}
      sx={{
        borderRight: cell.column.Header && "1px solid",
        borderBottom: "none",
        borderColor: "black_solid.30",
        backgroundColor: backgroundColor,
        padding: "6px 4px",
      }}
    >
      {isScrolling && (
        <Typography variant="body1" color="black_solid.80" className="Customized-table-overflow-cell">-</Typography>
      )}
      {!isScrolling && cell.render("Cell")}
    </TableCell>
  );
}

CustomizedTableBodyCell.propTypes = {
  style: PropTypes.object.isRequired,
  backgroundColor: PropTypes.string,
  index: PropTypes.number.isRequired,
  cell: PropTypes.object.isRequired,
  isScrolling: PropTypes.bool,
  onClick: PropTypes.func,
};